import { convertIframes } from "../utils/convert_iframes";

const articleBody = document.querySelector(".v_newsroom_show__article_body");
if (articleBody) {
  convertIframes(articleBody);
}
